/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminEbayAspect,
    AdminEbayAspectFromJSON,
    AdminEbayAspectFromJSONTyped,
    AdminEbayAspectToJSON,
} from './AdminEbayAspect';
import {
    AdminEbayCondition,
    AdminEbayConditionFromJSON,
    AdminEbayConditionFromJSONTyped,
    AdminEbayConditionToJSON,
} from './AdminEbayCondition';

/**
 * 
 * @export
 * @interface AdminEbayCategoryResp
 */
export interface AdminEbayCategoryResp {
    /**
     * 
     * @type {Array<AdminEbayAspect>}
     * @memberof AdminEbayCategoryResp
     */
    aspects: Array<AdminEbayAspect>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminEbayCategoryResp
     */
    conditionRequired: boolean;
    /**
     * 
     * @type {Array<AdminEbayCondition>}
     * @memberof AdminEbayCategoryResp
     */
    conditions: Array<AdminEbayCondition>;
    /**
     * SuggestedCondition is the product's condition mapped to one the category accepts.
     * @type {string}
     * @memberof AdminEbayCategoryResp
     */
    suggestedCondition: string;
}

export function AdminEbayCategoryRespFromJSON(json: any): AdminEbayCategoryResp {
    return AdminEbayCategoryRespFromJSONTyped(json, false);
}

export function AdminEbayCategoryRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayCategoryResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aspects': ((json['aspects'] as Array<any>).map(AdminEbayAspectFromJSON)),
        'conditionRequired': json['conditionRequired'],
        'conditions': ((json['conditions'] as Array<any>).map(AdminEbayConditionFromJSON)),
        'suggestedCondition': json['suggestedCondition'],
    };
}

export function AdminEbayCategoryRespToJSON(value?: AdminEbayCategoryResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aspects': ((value.aspects as Array<any>).map(AdminEbayAspectToJSON)),
        'conditionRequired': value.conditionRequired,
        'conditions': ((value.conditions as Array<any>).map(AdminEbayConditionToJSON)),
        'suggestedCondition': value.suggestedCondition,
    };
}

